import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionGrid = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"type": "page",
			"properties": {
				"title": [
					[
						"Структура и сетка"
					]
				]
			},
			"content": [
				"6defa559-250d-4c95-9777-91ee39bda6ca",
				"a9a610b7-3b33-44f4-86c1-edb4f00910a3",
				"190278cc-a31a-4f85-aa26-1c66db838cdd",
				"69d52da7-f258-453f-8046-dfc1f0446514",
				"cab19113-412c-4299-9566-067f8e14090e",
				"82e18090-1f61-4422-9ad3-7875fceca00c",
				"59b53ace-7ed7-426d-9ab0-910f0ff2f38d",
				"0fb21603-c18a-4b90-bbd0-c865a7628cf6",
				"e8d5bf2b-3ded-465f-825d-9bc3ba2d0f52",
				"2a801d07-2ea4-4196-8097-ae3b3058d8e2",
				"9151d43b-cf9d-4170-abd1-e2fcb4970fbc",
				"01b700b4-2068-4ee7-bed1-13b6588a67df",
				"c4531919-775f-428a-a3ee-d1307a120b58",
				"af25b7a1-4f4a-4062-8ac4-d1e94b4fd8f7",
				"85d20b22-b7c3-4767-bb55-5254d7ab9f71",
				"caff88ac-32b6-4297-bade-d8344a1b36c0",
				"b1b6ae30-339a-4e69-ae1b-df716bb21c42",
				"9e8a2e76-80d3-458c-91e0-60f5e0e34260",
				"f17d6299-af6d-4cbe-a6a2-34df771bc689",
				"f9816d4e-f062-4c97-951f-0ef8ab090495",
				"5280e4cf-b56e-44a9-a8e4-fa1a510039f4",
				"1e82af48-5dbe-4204-b3f1-8631b0e08272",
				"17a62200-b97f-405b-b909-b08e7aba40b1",
				"205ff943-4434-490d-8d72-07ba58317e5a",
				"bdcb687b-8f2c-4a62-9ea3-3149fd1bf892",
				"e902ee5e-b6c9-4c62-8f12-1fbaa90280db",
				"d7829105-00c8-44aa-ae6e-440f4fc96823",
				"554b058f-5865-4782-b778-1f78c94ff0d6",
				"f2aaaf12-c47e-4b05-b7e8-7aef64595065",
				"24bcec74-f5ec-4d6e-851a-8f3eeb4889f5",
				"62c887b7-c1a7-46af-bee7-5a8412d56f72",
				"fb0da0dc-c09d-4c44-a76c-acc0d23e8485",
				"2004740e-44f5-4e5b-8d3b-62c75ab743d9",
				"730eaf25-3af8-4457-a1ee-e285c12d23f1",
				"d71bf721-0556-4a7d-a3d6-b1282611c635",
				"bd5d3a4a-8764-43bb-85f2-80eda141c2d1",
				"1377a5c4-0b8d-42f4-bd59-24b01b5eba78",
				"d5403764-02d3-4918-99b0-4b510efc7d72",
				"410b84fd-4c85-4392-939f-5a0b305a1876",
				"b6210e8c-6b0e-4076-b68b-6cb43cb2a2bb",
				"df0beb8d-6abb-44fb-a49f-08ffbfe1fa44",
				"df46090b-3785-4de5-8a26-2a2903347e2a",
				"705e959e-f63e-4c25-ae66-d5909dd8fb2e",
				"75af0b32-8304-406f-b4d3-7a611ea9cc91",
				"5e55c2cc-8db8-4238-bdda-93d42e0517ec",
				"3385f9a7-7518-4bfe-9f14-fbb32d90bdc7",
				"f90499a8-1410-4740-9a07-352cf687a7e2",
				"26dfb665-3266-4a56-b436-5283758e8e5e",
				"99f3a460-987d-46bb-a0ea-fbc0487dda1c",
				"5ee81a96-60ea-430c-b675-58fb5f1caa18",
				"b300555f-7373-4bff-ac60-0a3d9d76ce80",
				"5e6d7d1e-3617-4c9d-85b5-a707f8a16c52"
			],
			"format": {
				"copied_from_pointer": {
					"id": "feaf69e1-4b36-4081-a9d1-72fd55b8b71b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"505dfb34-e327-4595-8f65-9ad6eb21433f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6defa559-250d-4c95-9777-91ee39bda6ca",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/grid\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a9a610b7-3b33-44f4-86c1-edb4f00910a3",
			"type": "text",
			"properties": {
				"title": [
					[
						"Лэйаут и сетка помогают пользователю понять визуальную иерархию интерфейса. Помимо структурирующей функции, лэйаут выполняет и утилитарную — стандартизирует основные компоненты продуктов, задаёт единый визуальный ритм."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0807071d-4a0d-44ce-b926-168b9cf69449",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "190278cc-a31a-4f85-aa26-1c66db838cdd",
			"type": "image",
			"properties": {
				"size": [
					[
						"96.2KB"
					]
				],
				"title": [
					[
						"image.png"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d28bb126-0c7f-4460-8426-08d7d7aa9825/image.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/d28bb126-0c7f-4460-8426-08d7d7aa9825/image.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"d28bb126-0c7f-4460-8426-08d7d7aa9825"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/190278cc-a31a-4f85-aa26-1c66db838cdd.png"
		},
		{
			"id": "69d52da7-f258-453f-8046-dfc1f0446514",
			"type": "text",
			"properties": {
				"title": [
					[
						"Лэйаут должен быть:"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "e3a940b4-c3cd-4ded-8f60-fe579252b2f0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cab19113-412c-4299-9566-067f8e14090e",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"консистентным между продуктами,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a4aa519b-b97b-4ad9-8ab4-61d3c96b7369",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "82e18090-1f61-4422-9ad3-7875fceca00c",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"предсказуемым,"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "65e82cd6-391c-4b94-9fc1-b3e34ecc79ef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "59b53ace-7ed7-426d-9ab0-910f0ff2f38d",
			"type": "bulleted_list",
			"properties": {
				"title": [
					[
						"адаптивным."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fff387c8-6cc0-4648-b244-44c1fa887ccc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0fb21603-c18a-4b90-bbd0-c865a7628cf6",
			"type": "header",
			"properties": {
				"title": [
					[
						"Консистентность"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fb4c12ce-5b04-4ef6-992e-fb66aa0032d7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e8d5bf2b-3ded-465f-825d-9bc3ba2d0f52",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы используем одинаковую структуру интерфейса внутри групп продуктивити и медиа."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3240cb18-3b8f-4936-b1b8-568f49ae9cca",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2a801d07-2ea4-4196-8097-ae3b3058d8e2",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Модульность "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "77b90d84-9110-4cd2-a496-c2d026d5d86c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9151d43b-cf9d-4170-abd1-e2fcb4970fbc",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для построения размерностей в интерфейсе мы используем сетку "
					],
					[
						"4dp",
						[
							[
								"b"
							]
						]
					],
					[
						". Единый модуль сетки необходим для поддержания общей логики в создании макетов и их разработке. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1e0b76b8-7fa0-425c-881c-db870e2524b7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "01b700b4-2068-4ee7-bed1-13b6588a67df",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8c8f6ccc-2982-4397-980b-a290d74b8541/module.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/8c8f6ccc-2982-4397-980b-a290d74b8541/module.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5535714285714286,
				"copied_from_pointer": {
					"id": "bfc48aa6-b708-4c7d-bfb7-1706beba97aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"8c8f6ccc-2982-4397-980b-a290d74b8541"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/01b700b4-2068-4ee7-bed1-13b6588a67df.png"
		},
		{
			"id": "c4531919-775f-428a-a3ee-d1307a120b58",
			"type": "header",
			"properties": {
				"title": [
					[
						"Предсказуемость"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "15065318-f4c3-42e7-94f4-dab011911c83",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "af25b7a1-4f4a-4062-8ac4-d1e94b4fd8f7",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Информационные слои"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "59dd2162-ba03-49cb-ad88-798efbfee63e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "85d20b22-b7c3-4767-bb55-5254d7ab9f71",
			"type": "text",
			"properties": {
				"title": [
					[
						"Элементы интерфейса имеют разное назначение или находятся на разных уровнях смысловой иерархии. Мы разделяем их на информационные слои."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0aecef70-a242-4205-9ffa-057091f9ad9c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "caff88ac-32b6-4297-bade-d8344a1b36c0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Информационные слои плоские, но имеют глубину относительно друг друга. Это позволяет быстрее разобраться в иерархии и функциях элементов интерфейса."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "71a00a97-d293-4ee9-aefe-0a866630e924",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b1b6ae30-339a-4e69-ae1b-df716bb21c42",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fca5dfb6-9e43-4347-91a6-39c222a5a782/infolayers.png"
					]
				]
			},
			"format": {
				"block_width": 2184,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fca5dfb6-9e43-4347-91a6-39c222a5a782/infolayers.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5535714285714286,
				"copied_from_pointer": {
					"id": "b0516973-804c-4303-a424-01ef2b8b6ab4",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"fca5dfb6-9e43-4347-91a6-39c222a5a782"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b1b6ae30-339a-4e69-ae1b-df716bb21c42.png"
		},
		{
			"id": "9e8a2e76-80d3-458c-91e0-60f5e0e34260",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Пользователю должно быть легко найти ключевую информацию или действия. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Чтобы пользователь погрузился в контекст, сопровождайте визуальные элементы кратким описанием. Не полагайтесь целиком на графику."
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "0dde39b7-2087-4f9f-8dbc-8bf223c7ce2c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f17d6299-af6d-4cbe-a6a2-34df771bc689",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "a43c02ad-e97a-4b4d-ae57-942403e358e5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f9816d4e-f062-4c97-951f-0ef8ab090495",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Структура макета"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7462b832-ae46-4a11-8cc8-5b210e138875",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5280e4cf-b56e-44a9-a8e4-fa1a510039f4",
			"type": "text",
			"properties": {
				"title": [
					[
						"Воздух",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "384ab907-d212-4eb0-9697-0c831b2c4722",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1e82af48-5dbe-4204-b3f1-8631b0e08272",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используйте воздух в сетке как инструмент визуальной иерархии."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1242ad49-5c7a-4f67-90b9-9d434f1bf69f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "17a62200-b97f-405b-b909-b08e7aba40b1",
			"type": "column_list",
			"content": [
				"fb90bc7b-382d-4d38-841e-28eaa59d5986",
				"a1943127-c1c7-4328-adb3-3912efd8011c"
			],
			"format": {
				"copied_from_pointer": {
					"id": "853ef7cc-a306-4715-b527-31dec5631528",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "205ff943-4434-490d-8d72-07ba58317e5a",
			"type": "column_list",
			"content": [
				"22fb0ccb-5ee1-4106-ae19-725efb370b6e",
				"488d2803-6658-4fa4-a3b9-9d8eef9d5979"
			],
			"format": {
				"copied_from_pointer": {
					"id": "77a41f62-27b9-4d64-9c08-ddba992d30e3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bdcb687b-8f2c-4a62-9ea3-3149fd1bf892",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "660c0207-7ae2-4ab6-84c0-1d39df708095",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e902ee5e-b6c9-4c62-8f12-1fbaa90280db",
			"type": "text",
			"properties": {
				"title": [
					[
						"Разделители",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b01085dd-522b-46f8-ad10-a20e533cd5f0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d7829105-00c8-44aa-ae6e-440f4fc96823",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы используем разделители только в случаях, когда без них хуже считывается информация и нарушается визуальная иерархия."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ff65d358-48a4-4b38-a34d-d06758512e82",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "554b058f-5865-4782-b778-1f78c94ff0d6",
			"type": "column_list",
			"content": [
				"bb94a4c8-7644-4989-ae10-981a683f4ad1",
				"b76bfc15-6d8b-4a8c-81b6-c0ad4b12b7a8"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f60205b8-ccfe-4e45-83ec-ad657640256c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f2aaaf12-c47e-4b05-b7e8-7aef64595065",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "b53d2086-d656-4c3a-84b6-5e9fe26d96a5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "24bcec74-f5ec-4d6e-851a-8f3eeb4889f5",
			"type": "column_list",
			"content": [
				"f7ea0e0e-f17b-4a8a-a8ba-33b5afe071b6",
				"67105266-49d8-4781-a5cc-44f403d5da10"
			],
			"format": {
				"copied_from_pointer": {
					"id": "7a5da20c-57ca-4f9a-a1a8-334af28ddcdf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "62c887b7-c1a7-46af-bee7-5a8412d56f72",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "a273abdf-2f3d-4d83-9108-e39ba348880f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb0da0dc-c09d-4c44-a76c-acc0d23e8485",
			"type": "text",
			"properties": {
				"title": [
					[
						"В многоколоночном лейауте разделители используются только в случаях, когда без них существенно повышается когнитивная нагрузка."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1701122f-6bb7-4066-ab4d-cfdfbaa20cc7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2004740e-44f5-4e5b-8d3b-62c75ab743d9",
			"type": "column_list",
			"content": [
				"4c6fb26d-925a-43d1-988a-eebea3fba4fb",
				"aa7132e9-01c9-4097-aab9-f4c1d2c47b73"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d940894a-7e87-4b0f-98ef-1a94c285e787",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "730eaf25-3af8-4457-a1ee-e285c12d23f1",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "f983fa46-a215-4d02-b8b1-6aa32930ecd1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d71bf721-0556-4a7d-a3d6-b1282611c635",
			"type": "text",
			"properties": {
				"title": [
					[
						"На списках мы используем разделители только для высоконагруженных элементов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "946ca6e2-71c3-46a4-b84f-840c2361334f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bd5d3a4a-8764-43bb-85f2-80eda141c2d1",
			"type": "column_list",
			"content": [
				"675bc2ec-3753-4d44-b0d8-ef248fc69225",
				"0ddeaf30-3d20-400d-b91a-64832c54b63d"
			],
			"format": {
				"copied_from_pointer": {
					"id": "f9d33e58-ba79-4b8c-9940-c7a9e615e0bb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1377a5c4-0b8d-42f4-bd59-24b01b5eba78",
			"type": "header",
			"properties": {
				"title": [
					[
						"Адаптивность"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "85344a84-ce32-4279-955c-5ee21eefc469",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d5403764-02d3-4918-99b0-4b510efc7d72",
			"type": "text",
			"properties": {
				"title": [
					[
						"В зависимости от типа продукта мы используем два подхода к адаптивности."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "df0e9200-0d32-4837-83fd-63e4c34af7e6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "410b84fd-4c85-4392-939f-5a0b305a1876",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Брейкпоинты",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2b05e564-23f5-41e0-a6f5-43ffb6b3b8d8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b6210e8c-6b0e-4076-b68b-6cb43cb2a2bb",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем в продуктах со сложным визуальным представлением, где важно гарантировать аккуратность, например, в Медиапроектах."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "dd8293ff-10f0-479d-a0c3-7f32c255ff69",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "df0beb8d-6abb-44fb-a49f-08ffbfe1fa44",
			"type": "text",
			"properties": {
				"title": [
					[
						"Медиапроекты используют сетку с модулем "
					],
					[
						"20dp",
						[
							[
								"b"
							]
						]
					],
					[
						". По краям экрана заложен минимальный отступ "
					],
					[
						"20dp",
						[
							[
								"b"
							]
						]
					],
					[
						", а также пространство под полосу прокрутки "
					],
					[
						"20dp",
						[
							[
								"b"
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "61242e55-652c-42b4-bc75-319b85e1ed98",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "df46090b-3785-4de5-8a26-2a2903347e2a",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cd1c907e-29d8-491e-9bbb-d154209744cf/MAIN.gif"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/cd1c907e-29d8-491e-9bbb-d154209744cf/MAIN.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "23f67557-4f1c-4ede-94f8-6547ccd7b192",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"cd1c907e-29d8-491e-9bbb-d154209744cf"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/df46090b-3785-4de5-8a26-2a2903347e2a.gif"
		},
		{
			"id": "705e959e-f63e-4c25-ae66-d5909dd8fb2e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"100% экрана",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "569f5f00-9f6a-47d2-ac54-f0337bd79ddc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "75af0b32-8304-406f-b4d3-7a611ea9cc91",
			"type": "text",
			"properties": {
				"title": [
					[
						"Используем в продуктах, где важно использовать всё экранное пространство: например, в Почте, Облаке, Календаре."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f6740320-f5f4-494b-8dea-13d374de08ef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e55c2cc-8db8-4238-bdda-93d42e0517ec",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для этого типа лейаута мы рекомендуем использовать структурную сетку, чтобы поддерживать ритм и стандартный модуль в "
					],
					[
						"4dp",
						[
							[
								"b"
							]
						]
					],
					[
						" для определения размерностей."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "32926fb9-935f-4be5-9d1b-209aaee1f9ef",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3385f9a7-7518-4bfe-9f14-fbb32d90bdc7",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e2f8befe-0280-4314-a385-9fb3f5edc648/MAIN.gif"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/e2f8befe-0280-4314-a385-9fb3f5edc648/MAIN.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "e5a662f5-5167-4047-af77-1257578b65a7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"e2f8befe-0280-4314-a385-9fb3f5edc648"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3385f9a7-7518-4bfe-9f14-fbb32d90bdc7.gif"
		},
		{
			"id": "f90499a8-1410-4740-9a07-352cf687a7e2",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Комбинированный вариант"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "37d59028-e747-4f58-92a6-a52057a9389c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26dfb665-3266-4a56-b436-5283758e8e5e",
			"type": "text",
			"properties": {
				"title": [
					[
						"По необходимости можно комбинировать разные подходы к адаптивности."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "cdd265e7-c3db-4fae-9940-ed4177a5ae6b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "99f3a460-987d-46bb-a0ea-fbc0487dda1c",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac9d44f6-5b0d-4420-a22c-2885de4a5d53/MAIN.gif"
					]
				]
			},
			"format": {
				"block_width": 582,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ac9d44f6-5b0d-4420-a22c-2885de4a5d53/MAIN.gif",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5631868131868132,
				"copied_from_pointer": {
					"id": "5b4d78fd-2fd3-44fb-9ad2-23bf386444e6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"ac9d44f6-5b0d-4420-a22c-2885de4a5d53"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/99f3a460-987d-46bb-a0ea-fbc0487dda1c.gif"
		},
		{
			"id": "5ee81a96-60ea-430c-b675-58fb5f1caa18",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Размерности",
						[
							[
								"b"
							]
						]
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "75365140-c249-4970-916d-e68248b4314b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b300555f-7373-4bff-ac60-0a3d9d76ce80",
			"type": "text",
			"properties": {
				"title": [
					[
						"У каждого проекта есть несколько типов сеток, к которым привязаны изменения в контролах и стилях типографики."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "8bc1ad6d-3d33-4ef5-9a23-91129cfbc797",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e6d7d1e-3617-4c9d-85b5-a707f8a16c52",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a49c91d1-b034-4fed-a7d3-9aa2b1002213/sizes.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a49c91d1-b034-4fed-a7d3-9aa2b1002213/sizes.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.6593406593406593,
				"copied_from_pointer": {
					"id": "8aef7d99-57fa-48fa-aba5-3d9314e18a78",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "1f51d543-236b-4b29-a278-4bed543f50b5",
			"parent_table": "block",
			"file_ids": [
				"a49c91d1-b034-4fed-a7d3-9aa2b1002213"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5e6d7d1e-3617-4c9d-85b5-a707f8a16c52.png"
		},
		{
			"id": "fb90bc7b-382d-4d38-841e-28eaa59d5986",
			"type": "column",
			"content": [
				"eb70d39b-638e-4e07-aa27-9cd6c87a3241",
				"d42923bf-f843-40b1-9cdb-3ea3ace07f25"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "3c4adbca-37f9-45e1-97b3-fc616dc92d94",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "17a62200-b97f-405b-b909-b08e7aba40b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a1943127-c1c7-4328-adb3-3912efd8011c",
			"type": "column",
			"content": [
				"b6cc7f2d-e90b-4612-ae1c-6c6a5eee6bf2",
				"9e4dc438-c20c-4f37-8168-ebcc33063c4f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "a861d9da-0bcd-4065-a7a9-7419e84abdb0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "17a62200-b97f-405b-b909-b08e7aba40b1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eb70d39b-638e-4e07-aa27-9cd6c87a3241",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ec0fc4ce-d923-4662-a26f-2f60cd6a22c0/air_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/ec0fc4ce-d923-4662-a26f-2f60cd6a22c0/air_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "9baaaf8f-05a6-486d-9bd2-c84f99971dc2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "fb90bc7b-382d-4d38-841e-28eaa59d5986",
			"parent_table": "block",
			"file_ids": [
				"ec0fc4ce-d923-4662-a26f-2f60cd6a22c0"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/eb70d39b-638e-4e07-aa27-9cd6c87a3241.png"
		},
		{
			"id": "d42923bf-f843-40b1-9cdb-3ea3ace07f25",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Воздух помогает считать информацию"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "4e74af61-6d57-4a45-97bc-7039a0a8f5f2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fb90bc7b-382d-4d38-841e-28eaa59d5986",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b6cc7f2d-e90b-4612-ae1c-6c6a5eee6bf2",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/72e314c6-bebb-486b-8ef9-2fadfa44a29c/air_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/72e314c6-bebb-486b-8ef9-2fadfa44a29c/air_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "eef13e31-8b19-44e4-8d9b-fd965dbbbc16",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "a1943127-c1c7-4328-adb3-3912efd8011c",
			"parent_table": "block",
			"file_ids": [
				"72e314c6-bebb-486b-8ef9-2fadfa44a29c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/b6cc7f2d-e90b-4612-ae1c-6c6a5eee6bf2.png"
		},
		{
			"id": "9e4dc438-c20c-4f37-8168-ebcc33063c4f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Интерфейс слишком зажат"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ebf6cbc1-d19e-4ba1-9e5d-de382b4a253f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a1943127-c1c7-4328-adb3-3912efd8011c",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "22fb0ccb-5ee1-4106-ae19-725efb370b6e",
			"type": "column",
			"content": [
				"5e016020-e808-404b-9392-67e2a55a0f2e",
				"f4279c58-9ba6-4272-8403-f5e3e5dd23be"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "48425e16-a4c6-4985-b518-97cfa8ede277",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "205ff943-4434-490d-8d72-07ba58317e5a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "488d2803-6658-4fa4-a3b9-9d8eef9d5979",
			"type": "column",
			"content": [
				"241f22cb-4af0-4d20-a9bc-823352917120",
				"b5bd648d-fff1-4ac7-9170-da9a3bceee5d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "4a5e9b9d-80b7-4b28-99f0-eac6f89e309a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "205ff943-4434-490d-8d72-07ba58317e5a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e016020-e808-404b-9392-67e2a55a0f2e",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9ed58d0d-6476-44aa-8c79-f2437d5540fe/air2_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9ed58d0d-6476-44aa-8c79-f2437d5540fe/air2_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8982558139534884,
				"copied_from_pointer": {
					"id": "a0c0b1c0-306c-4724-a4f7-3d8a5e793b66",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "22fb0ccb-5ee1-4106-ae19-725efb370b6e",
			"parent_table": "block",
			"file_ids": [
				"9ed58d0d-6476-44aa-8c79-f2437d5540fe"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5e016020-e808-404b-9392-67e2a55a0f2e.png"
		},
		{
			"id": "f4279c58-9ba6-4272-8403-f5e3e5dd23be",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Структура интерфейса хорошо считывается благодаря воздуху"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5f4bd6f8-49fd-4a76-8f70-17f16d959aea",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "22fb0ccb-5ee1-4106-ae19-725efb370b6e",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "241f22cb-4af0-4d20-a9bc-823352917120",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5be648bc-05fe-4db1-bb73-6f5ea1d26819/air2_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/5be648bc-05fe-4db1-bb73-6f5ea1d26819/air2_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8982558139534884,
				"copied_from_pointer": {
					"id": "3fb1dafb-a327-4881-8e92-4a4ea23d0c6a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "488d2803-6658-4fa4-a3b9-9d8eef9d5979",
			"parent_table": "block",
			"file_ids": [
				"5be648bc-05fe-4db1-bb73-6f5ea1d26819"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/241f22cb-4af0-4d20-a9bc-823352917120.png"
		},
		{
			"id": "b5bd648d-fff1-4ac7-9170-da9a3bceee5d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Колонки слипаются, из-за чего рушится иерархия лэйаута"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "44352df4-9045-4a00-9f52-dd39935eb8b0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "488d2803-6658-4fa4-a3b9-9d8eef9d5979",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bb94a4c8-7644-4989-ae10-981a683f4ad1",
			"type": "column",
			"content": [
				"dd82f14c-727a-46ea-bd6d-a609776f959d",
				"a2ca1f26-49b1-4b9e-be78-ea74314d7aa7"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "189f2cbf-c7df-456a-88ff-cf72678b2698",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "554b058f-5865-4782-b778-1f78c94ff0d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b76bfc15-6d8b-4a8c-81b6-c0ad4b12b7a8",
			"type": "column",
			"content": [
				"50f1af4d-0ac3-4198-98bd-ac7e1214674e",
				"257d8cb3-3da2-4cbb-9de0-3482056288dd"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "2473cea7-137f-436f-b74b-c24880c132cb",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "554b058f-5865-4782-b778-1f78c94ff0d6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dd82f14c-727a-46ea-bd6d-a609776f959d",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0358f1a1-8686-4f09-b0a1-680f30c7d5b4/borders_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0358f1a1-8686-4f09-b0a1-680f30c7d5b4/borders_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "77008e49-3c50-489d-ac30-99cdd355d829",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "bb94a4c8-7644-4989-ae10-981a683f4ad1",
			"parent_table": "block",
			"file_ids": [
				"0358f1a1-8686-4f09-b0a1-680f30c7d5b4"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/dd82f14c-727a-46ea-bd6d-a609776f959d.png"
		},
		{
			"id": "a2ca1f26-49b1-4b9e-be78-ea74314d7aa7",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Иерархия элементов поддерживается благодаря воздуху"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "33430bf9-00c5-4595-835d-2c9bf9ee587b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bb94a4c8-7644-4989-ae10-981a683f4ad1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "50f1af4d-0ac3-4198-98bd-ac7e1214674e",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ebbea6a-b1ec-4ff8-ac5b-8e76c1978715/borders_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ebbea6a-b1ec-4ff8-ac5b-8e76c1978715/borders_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "af7480ed-806a-4385-8269-13d128fcf9f5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "b76bfc15-6d8b-4a8c-81b6-c0ad4b12b7a8",
			"parent_table": "block",
			"file_ids": [
				"0ebbea6a-b1ec-4ff8-ac5b-8e76c1978715"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/50f1af4d-0ac3-4198-98bd-ac7e1214674e.png"
		},
		{
			"id": "257d8cb3-3da2-4cbb-9de0-3482056288dd",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Разделители усложняют восприятие списка "
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5b2c2a30-934b-475f-b50b-f952ff30bcc7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "b76bfc15-6d8b-4a8c-81b6-c0ad4b12b7a8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f7ea0e0e-f17b-4a8a-a8ba-33b5afe071b6",
			"type": "column",
			"content": [
				"f694e154-cdae-4566-abf4-5249c3b32b9d",
				"07043f1f-8110-4723-a564-04f1a7f13a4a"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "de124fdd-3536-4fc9-b365-8765f6712709",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "24bcec74-f5ec-4d6e-851a-8f3eeb4889f5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "67105266-49d8-4781-a5cc-44f403d5da10",
			"type": "column",
			"content": [
				"e9f6c036-7535-4c7b-96d8-31eaec177f3f",
				"38308c71-51f1-45bd-9c09-97e8e7f5b623"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8a364354-c8e4-49fa-af13-4070e59dceaa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "24bcec74-f5ec-4d6e-851a-8f3eeb4889f5",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f694e154-cdae-4566-abf4-5249c3b32b9d",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0f9207de-57cd-4e25-b118-3159556dd089/borders2_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0f9207de-57cd-4e25-b118-3159556dd089/borders2_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.2267441860465116,
				"copied_from_pointer": {
					"id": "c45af427-376d-45be-b8f0-e751d2593075",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "f7ea0e0e-f17b-4a8a-a8ba-33b5afe071b6",
			"parent_table": "block",
			"file_ids": [
				"0f9207de-57cd-4e25-b118-3159556dd089"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/f694e154-cdae-4566-abf4-5249c3b32b9d.png"
		},
		{
			"id": "07043f1f-8110-4723-a564-04f1a7f13a4a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Форма хорошо структурирована"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "61bb0087-f1eb-47b3-a224-c3727b8c70bc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "f7ea0e0e-f17b-4a8a-a8ba-33b5afe071b6",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e9f6c036-7535-4c7b-96d8-31eaec177f3f",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7700d553-c825-465d-a01d-a484dc5332fb/borders2_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/7700d553-c825-465d-a01d-a484dc5332fb/borders2_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1.2267441860465116,
				"copied_from_pointer": {
					"id": "2cea77c9-761b-42a6-8d01-a91f3b4f3ea1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "67105266-49d8-4781-a5cc-44f403d5da10",
			"parent_table": "block",
			"file_ids": [
				"7700d553-c825-465d-a01d-a484dc5332fb"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e9f6c036-7535-4c7b-96d8-31eaec177f3f.png"
		},
		{
			"id": "38308c71-51f1-45bd-9c09-97e8e7f5b623",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Разделители без необходимости увеличивают высоту"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "936c3e90-424b-4c6c-8591-a78b3b4584aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "67105266-49d8-4781-a5cc-44f403d5da10",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4c6fb26d-925a-43d1-988a-eebea3fba4fb",
			"type": "column",
			"content": [
				"ee736383-9a2a-433c-a35e-bcfb1451ef20",
				"b346ea4c-0862-4d4b-8d41-8d6865d0b30b"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "f284d505-d17b-4e87-a28a-01c363e2e9ee",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2004740e-44f5-4e5b-8d3b-62c75ab743d9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "aa7132e9-01c9-4097-aab9-f4c1d2c47b73",
			"type": "column",
			"content": [
				"698a2eaa-31c6-499f-8039-f3d4fcb0ab79",
				"7c90a421-874b-4e87-b7a3-61da7038fe4d"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "2eb7c05b-4d5d-46d7-a502-7b995a8d905a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2004740e-44f5-4e5b-8d3b-62c75ab743d9",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "ee736383-9a2a-433c-a35e-bcfb1451ef20",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c6ecd653-f5aa-4746-80a7-4bfd3d4a1b3f/columns_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c6ecd653-f5aa-4746-80a7-4bfd3d4a1b3f/columns_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8982558139534884,
				"copied_from_pointer": {
					"id": "940113f5-8069-4c38-a224-46b2a0c1ee07",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "4c6fb26d-925a-43d1-988a-eebea3fba4fb",
			"parent_table": "block",
			"file_ids": [
				"c6ecd653-f5aa-4746-80a7-4bfd3d4a1b3f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/ee736383-9a2a-433c-a35e-bcfb1451ef20.png"
		},
		{
			"id": "b346ea4c-0862-4d4b-8d41-8d6865d0b30b",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Структура интерфейса хорошо считывается благодаря достаточному воздуху"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "81d63669-c2ff-4ef2-99e1-d048514c9c7d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "4c6fb26d-925a-43d1-988a-eebea3fba4fb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "698a2eaa-31c6-499f-8039-f3d4fcb0ab79",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b4e19c3-b379-4b20-b6df-de09ed124b52/columns_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0b4e19c3-b379-4b20-b6df-de09ed124b52/columns_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8982558139534884,
				"copied_from_pointer": {
					"id": "9425f8b8-28cd-4e23-863f-b8979664dd5e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "aa7132e9-01c9-4097-aab9-f4c1d2c47b73",
			"parent_table": "block",
			"file_ids": [
				"0b4e19c3-b379-4b20-b6df-de09ed124b52"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/698a2eaa-31c6-499f-8039-f3d4fcb0ab79.png"
		},
		{
			"id": "7c90a421-874b-4e87-b7a3-61da7038fe4d",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Разделители не помогают ориентироваться в интефрейсе, а только делают его «зажатым»"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1bb5f9b3-cb09-4aaa-8ffa-e3d14a0650c9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "aa7132e9-01c9-4097-aab9-f4c1d2c47b73",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "675bc2ec-3753-4d44-b0d8-ef248fc69225",
			"type": "column",
			"content": [
				"a1e20124-6768-4dbc-8182-990faa380948",
				"203c96a8-0c18-4a94-95b8-1cf1b7c874c3"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "03de0495-3906-4173-b65a-30151806c0a8",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bd5d3a4a-8764-43bb-85f2-80eda141c2d1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0ddeaf30-3d20-400d-b91a-64832c54b63d",
			"type": "column",
			"content": [
				"28c8a280-7e01-4e3d-8380-71e9d2794c3e",
				"0a8807a9-e1a4-44f5-a267-b2d81f4d3e89"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "c6786737-03db-4e4c-ad1e-d4f53edec113",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bd5d3a4a-8764-43bb-85f2-80eda141c2d1",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a1e20124-6768-4dbc-8182-990faa380948",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21502296-a5fb-42c9-8d22-724b1364c873/structure_y.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/21502296-a5fb-42c9-8d22-724b1364c873/structure_y.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "94b7c06f-b193-4a60-b579-74e23017d24b",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "675bc2ec-3753-4d44-b0d8-ef248fc69225",
			"parent_table": "block",
			"file_ids": [
				"21502296-a5fb-42c9-8d22-724b1364c873"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a1e20124-6768-4dbc-8182-990faa380948.png"
		},
		{
			"id": "203c96a8-0c18-4a94-95b8-1cf1b7c874c3",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Структура интерфейса хорошо считывается благодаря достаточному воздуху"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ec7d67ce-f97a-4780-9c28-89f22d148773",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "675bc2ec-3753-4d44-b0d8-ef248fc69225",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "28c8a280-7e01-4e3d-8380-71e9d2794c3e",
			"type": "image",
			"properties": {
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/65640bbb-714a-4eb6-8f0f-8d5a0204d81c/structure_n.png"
					]
				]
			},
			"format": {
				"block_width": 688,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/65640bbb-714a-4eb6-8f0f-8d5a0204d81c/structure_n.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 1,
				"copied_from_pointer": {
					"id": "c4e53585-4721-485a-ab7a-303a014e01f6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				},
				"block_preserve_scale": true
			},
			"parent_id": "0ddeaf30-3d20-400d-b91a-64832c54b63d",
			"parent_table": "block",
			"file_ids": [
				"65640bbb-714a-4eb6-8f0f-8d5a0204d81c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/28c8a280-7e01-4e3d-8380-71e9d2794c3e.png"
		},
		{
			"id": "0a8807a9-e1a4-44f5-a267-b2d81f4d3e89",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Без разделителей элементы списка разваливаются, и сканирование списка писем усложняется"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "54959e64-07ee-4423-9cba-1b7efa2d0c5f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0ddeaf30-3d20-400d-b91a-64832c54b63d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "Консистентность",
			"id": "0fb21603-c18a-4b90-bbd0-c865a7628cf6"
		},
		{
			"title": "Предсказуемость",
			"id": "c4531919-775f-428a-a3ee-d1307a120b58"
		},
		{
			"title": "Адаптивность",
			"id": "1377a5c4-0b8d-42f4-bd59-24b01b5eba78"
		}
	]
}} />
);

export default NotionGrid;
